import "./backToTop.scss";
import { rightArrowWhitebg } from "../../images";

const BackToTop = () => {
  const scrollHandler = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="backtotop_container" onClick={scrollHandler}>
        <img
          className="scrollup_img"
          src={rightArrowWhitebg}
          alt="arrow"
          loading="lazy"
          width="78"
          height="78"
        />
      </div>
    </>
  );
};

export default BackToTop;
